/* import __COLOCATED_TEMPLATE__ from './scim-admin-bulk-role-assignment-details.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type AppAdminEvent from 'embercom/models/app-admin-event';

interface ScimAdminBulkRoleAssignmentDetailsSignature {
  Args: {
    event: AppAdminEvent;
  };
}

export default class ScimAdminBulkRoleAssignmentDetails extends Component<ScimAdminBulkRoleAssignmentDetailsSignature> {
  @tracked showModal = false;

  @action
  toggleModal() {
    this.showModal = !this.showModal;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::AdminEvents::ScimAdminBulkRoleAssignmentDetails': typeof ScimAdminBulkRoleAssignmentDetails;
    'table-cells/admin-events/scim-admin-bulk-role-assignment-details': typeof ScimAdminBulkRoleAssignmentDetails;
  }
}
